import { Box, Tab, Tabs } from "@mui/material";
import { Outlet, useMatches, useNavigate } from "react-router";
import { useMemo } from "react";

const PageLabelsHeader = () => {
  const matches = useMatches();
  const value = useMemo(() => {
    const isImport = matches.find((m) => m.id === "lens-editor/lens/page-labels-import");
    const isSystem = matches.find((m) => m.id === "lens-editor/lens/system");
    if (isImport !== undefined) return "import";
    if (isSystem !== undefined) return "system";
    return "list";
  }, [matches]);
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Tabs
        value={value}
        onChange={(_evt, value) => {
          navigate(`./${value}`);
        }}>
        <Tab label="Page Labels" value="list" />
        <Tab label="Import" value="import" />
        <Tab label="System Page Labels" value="system" />
      </Tabs>
      <Box sx={{ minHeight: 0 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default PageLabelsHeader;
